// extracted by mini-css-extract-plugin
export default {"checkbox":"CustomCheckbox_checkbox__itxZN","checked":"CustomCheckbox_checked__BzuOj","title":"CustomCheckbox_title__OJWuB","checkboxHolder":"CustomCheckbox_checkboxHolder__mjgxB"};